exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner[data-v-2b0c80d6] {\n  -webkit-animation: spin 2s infinite linear;\n          animation: spin 2s infinite linear;\n}\n", ""]);

// exports
